module.exports = __webpack_public_path__ + "static/api_key_creation_result-3d796190e168732bf064afe4ac0ad31f.png";